<template src="./paymentInfoDetails.template.html"></template>
<script>
  import moment from "moment-timezone";
  import VeeValidate from "vee-validate";
  // import GoogleAutocomplete from 'google-autocomplete-vue';
  import VueGoogleAutocomplete from "vue-google-autocomplete";
  Vue.use(VeeValidate);
  import Vue from "vue";
  const phoneOrEmailRule = {
    getMessage(field, args) {
      return `The ${field} must be a valid phone number`;
    },
    validate(value, args) {
      // Custom regex for a phone number
      const MOBILEREG = /^[- +()]*[0-9][- +()0-9]*/;
      // Check for either of these to return true
      return VeeValidate.Rules.email(value) || MOBILEREG.test(value);
    },
  };
  VeeValidate.Validator.extend("phone", phoneOrEmailRule);
  export default {
    name: "paymentInfo",
    props: [],
    data() {
      return {
        apiUrl:
          window.location.protocol +
          "//" +
          window.location.hostname +
          (window.location.port ? ":1339" : ""),
        emailRegEx: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        showGuestDetails: false,
        ShowPaymentDetails: true,
        showTACdetails: false,
        showGuestChangeButton: false,
        showPaymentChangeButton: false,
        showTACChangeButton: false,
        showGuestDetail: false,
        // ThankuPage: false,
        selectedUnit: {},
        // guestInfo: {},
        guestInfo: {
          Emailaddress: "",
          PhoneNumber: "",
        },
        loading: false,
        content: {},
        ShowTermsAndConditions: false,
        selectedStateAndCountry: {},
        searchCountry: "",
        searchCity: "",
        searchState: "",
        selectedAddress: "",
        countryList: [],
        cityList: [],
        stateList: [],
        selectedCityObj: {},
        today: moment().format("YYYY-MM-DD HH:mm:ss"),
        ReservationId: -1,
        confirmationNumber: null,
        StatusName: null,
        folioItemCharges: [],
        folioCharges: {},
        additionalEmails: [],
        additionalPhoneNumbers: [],
        paymentCardType: null,
        addressAndZipcodeShow: false,
        isSelectedFromList: false,
        enableCompleteButton: false,
        cardInfo: {
          PaymentTypeId: null,
          NameOnCard: "",
          CreditCard: null,
          PaymentTypeId: null,
          Expirationdate: null,
          CVVCode: null,
          PaymentInfoId: null,
          ExpirationMonth: null,
          ExpirationYear: null,
          AddressDetails: null,
          PostalCode: null,
        },
        selectedPaymentCardDetails: {},
        stripeConnectedAccount: {},
        stripePaltformAccount: {},
        commissionAmmount: {},
        processingSurchargeLedgerAccount: {},
        cardTokenFromStripe: null,
        stripecardId: null,
        cardToken: {},
        paymentLedgerAcounts: [],
        isChecked: false,
        hashUrlReservationId: -1,
        statusId: 10,
        months: [
          { name: "January", value: "01" },
          { name: "February", value: "02" },
          { name: "March", value: "03" },
          { name: "April", value: "04" },
          { name: "May", value: "05" },
          { name: "June", value: "06" },
          { name: "July", value: "07" },
          { name: "August", value: "08" },
          { name: "September", value: "09" },
          { name: "October", value: "10" },
          { name: "November", value: "11" },
          { name: "December", value: "12" },
        ],
        showGuestInfo: true,
        showPriceInfo: false,
        showPriceText: "Details",
        showAddr: false,
        addressText: "Address",
        isWebView: null,
        errorMessage: "",
        disabledCompleteBookingButton: false
      };
    },
    methods: {
      closeShoppingCart() {
        let vm = this;
        vm.$store.state.filterObj.startDate = null
        vm.$store.state.filterObj.endDate = null

        vm.$store.state.filterObj.RatePlanId = null
        vm.$store.state.filterObj.Promocode = null
        vm.$store.state.bus.$emit("defaultsearchfromfiles", vm.filterObj);
        vm.$router.push("/availabilitySearch");
        // vm.$store.state.filterObj.startDate = null
        // vm.$store.state.filterObj.endDate = null
        // vm.$store.state.filterObj.RatePlanId = null
        // vm.$store.state.filterObj.Promocode = null
        // vm.$store.state.bus.$emit("shoppingCart");
      },
      showAddress() {
        this.showAddr = !this.showAddr;
        if (this.showAddr) {
          this.addressText = "Close Address";
        } else {
          this.addressText = "Address";
        }
      },
      showPriceDetails() {
        this.showPriceInfo = !this.showPriceInfo;
        if (this.showPriceInfo) {
          this.showPriceText = "Close";
        } else {
          this.showPriceText = "Details";
        }
      },
      resetAddress() {
        let vm = this;
        vm.guestInfo.Address = "";
        this.$set(this.guestInfo, "PostalCode", "");
        this.$set(this.guestInfo, "CityName", "");
        this.$set(this.guestInfo, "StateName", "");
        this.$set(this.guestInfo, "CountryName", "");
      },
      // getAddress(address) {
      //     let vm = this;
      //     console.log("addressaddressaddressaddressaddress", address);
      //     vm.guestInfo.Address = address;
      //     var add = address.split(",");
      //     vm.guestInfo.Address = add[0];
      //     console.log("vm.guestInfo.Address",vm.guestInfo.Address);
      // },
      getAddressData: function (addressData, placeResultData, id) {
        console.log("addressData", addressData);
        if (addressData && addressData.street_number && addressData.route) {
          this.guestInfo.Address =
            addressData.street_number + " " + addressData.route;
        } else {
          this.guestInfo.Address = addressData.route;
        }
        if (addressData && addressData.locality) {
          this.$set(this.guestInfo, "CityName", addressData.locality);
        } else if (addressData && addressData.administrative_area_level_2) {
          this.$set(
            this.guestInfo,
            "CityName",
            addressData.administrative_area_level_2
          );
        } else {
          this.$set(this.guestInfo, "CityName", "");
        }
        this.$set(this.guestInfo, "PostalCode", addressData.postal_code);
        this.$set(
          this.guestInfo,
          "StateName",
          addressData.administrative_area_level_1
        );
        this.$set(this.guestInfo, "CountryName", addressData.country);
        this.$set(this.guestInfo, "shortAddress", this.guestInfo.Address);
        console.log("this.guestInfo.PostalCode", this.guestInfo.PostalCode);
      },
      // getAddressData: function (addressData, placeResultData, id) {
      //     this.address = addressData;
      //     console.log("addressData", addressData)
      //     this.$set(this.guestInfo, 'PostalCode', addressData.postal_code);
      //     this.$set(this.guestInfo, 'CityName', addressData.locality);
      //     this.$set(this.guestInfo, 'StateName', addressData.administrative_area_level_1);
      //     this.$set(this.guestInfo, 'CountryName', addressData.country);
      //     console.log("this.guestInfo.PostalCode", this.guestInfo.PostalCode);
      // },
      // changeMethod(field) {
      //     let vm = this;
      //     vm.guestInfo.PostalCode = this.guestInfo.PostalCode;
      //     console.log("vm.guestInfo.PostalCodevm.guestInfo.PostalCode",vm.guestInfo.PostalCode);
      // },
      enableCBbutton() {
        let vm = this;
        console.log("vm.isChecked", vm.isChecked);
        if (vm.isChecked == true) {
          vm.enableCompleteButton = true;
        } else {
          vm.enableCompleteButton = false;
        }
      },
      showTermsAndConditions() {
        let vm = this;
        let routeData = this.$router.resolve({
          name: "termsAndConditions",
          params: { confirmationNumber: vm.$route.params.confirmationNumber },
        });
        window.open(routeData.href, "_blank");
        //    vm.$router.push("/termsAndConditions/" + vm.$route.params.ReservationId);
      },
      showAddressAndZipcode() {
        let vm = this;
        vm.addressAndZipcodeShow = !vm.addressAndZipcodeShow;
      },
      GetCardType(number) {
        let vm = this;
        vm.paymentCardType = null;
        // visa
        var re = new RegExp("^4");
        if (number.match(re) != null) {
          vm.paymentCardType = "Visa";
          // vm.cardInfo.PaymentTypeId = 8;
          return "Visa";
        }
        // Mastercard
        // Updated for Mastercard 2017 BINs expansion
        // if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
        //     {vm.paymentCardType = "MasterCard"
        //     return {cardType:"Mastercard",paymentTypeId:9};
        //     }
        re = new RegExp(
          "^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}"
        );
        if (number.match(re) != null) {
          vm.paymentCardType = "MasterCard";
          // vm.cardInfo.PaymentTypeId = 9;
          return "Mastercard";
        }
        // AMEX
        re = new RegExp("^3[47]\\d{0,13}"); //new RegExp("^3[47]");
        if (number.match(re) != null) {
          vm.paymentCardType = "American Express";
          // vm.cardInfo.PaymentTypeId = 7;
          return "AMEX";
        }
        // Discover ^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)
        re = new RegExp("(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}");
        if (number.match(re) != null) {
          vm.paymentCardType = "Discover";
          // vm.cardInfo.PaymentTypeId = 10;
          return "Discover";
        } else {
          vm.paymentCardType = "Other";
          return "Other";
        }
        // // Diners
        // re = new RegExp("^36");
        // if (number.match(re) != null)
        //   {vm.paymentCardType = "Diners"
        //   return {cardType:"Diners",paymentTypeId:7};}
        // // Diners - Carte Blanche
        // re = new RegExp("^30[0-5]");
        // if (number.match(re) != null)
        //   {vm.paymentCardType = "Diners"
        //   return {cardType:"Diners - Carte Blanche",paymentTypeId:7};}
        // // JCB
        // re = new RegExp("^35(2[89]|[3-8][0-9])");
        // if (number.match(re) != null)
        //   {vm.paymentCardType = "JCB"
        //   return {cardType:"JCB",paymentTypeId:7};}
        // // Visa Electron
        // re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        // if (number.match(re) != null)
        //   {vm.paymentCardType = "Visa Electron"
        //   return {cardType:"Visa Electron",paymentTypeId:7};}
        return "";
      },
      GetReservationDetailById: function () {
        let vm = this;
        console.log("vm.hashUrlReservationId======?", vm.hashUrlReservationId);
        // if (vm.hashUrlReservationId == "-1") {
        //     console.log("vm.unit", vm.unit);
        vm.selectedUnit = vm.unit;
        //     vm.showGuestDetails = true;
        //     vm.ShowPaymentDetails = false;
        //     // vm.ThankuPage = false;
        //     vm.GetFolioLedgerTransDetails_beforesave();
        // }
        // else {
        vm.showGuestDetails = false;
        vm.ShowPaymentDetails = false;
        // vm.ThankuPage = false;
        // }
        let obj = {
          ModuleAction: "GetReservationDetailById",
          ReservationId: vm.hashUrlReservationId,
          BE_Id: null,
        };
        let sucessCallback = function (response) {
          if (response.data) {
            console.log("GetReservationDetailById====>cv", response.data);
            vm.guestInfo = response.data.guestInfo;
            vm.roomInfo = response.data.roomInfo
            console.log("vm.guestInfo", vm.guestInfo);
            vm.guestInfo.Emailaddress =
              response.data.additionalEmails &&
                response.data.additionalEmails[0] &&
                response.data.additionalEmails[0].Emailaddress
                ? response.data.additionalEmails[0].Emailaddress
                : vm.guestInfo.Email;
            vm.guestInfo.PhoneNumber =
              response.data.additionalPhoneNumbers &&
                response.data.additionalPhoneNumbers[0] &&
                response.data.additionalPhoneNumbers[0].PhoneNumber
                ? response.data.additionalPhoneNumbers[0].PhoneNumber
                : vm.guestInfo.PhoneNumber;
            vm.searchCity = response.data.guestInfo.CityName;
            vm.searchCountry = response.data.guestInfo.CountryName;
            vm.searchState = response.data.guestInfo.StateName;
            if (response.data.roomInfo.UnitId) {
              vm.selectedUnit = response.data.roomInfo;
              vm.filterObj.startDate = response.data.roomInfo.originalStartDate;
              vm.filterObj.endDate = response.data.roomInfo.originalEndDate;
              vm.filterObj.Adults = response.data.roomInfo.NumberOfAdults;
              vm.filterObj.Children = response.data.roomInfo.NumberOfChildren;
              vm.filterObj.Persons = response.data.roomInfo.Persons;
              vm.statusId = response.data.roomInfo.Reservation_Status;
            }
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/GetReservationDetailById",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      formatMoney(amount) {
        return this.$store.state.getFormattedAmount("$", amount);
      },

      scrollPaymentPage() {
        let vm = this;
        if (vm.isWebView == false && window.innerHeight < window.innerWidth) {
          console.log(
            "gdsafffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
          );
          // setTimeout(() => {
          // var etop = $(".dataPanelSlide").offset().top - 75;
          // $('html, body').animate({
          //     scrollTop: etop
          // }, 350);hn
          // }, 100)
          // $("html, body").animate({ scrollTop: 0 });
        } else {
          $("html, body").animate({ scrollTop: 0 });
        }
      },
      formatEndDate(date) {
        let vm = this;
        let startYear = moment(
          vm.$store.state.filterObj.startDate,
          "YYYY-MM-DD"
        ).format("YYYY");
        let endYear = moment(
          vm.$store.state.filterObj.endDate,
          "YYYY-MM-DD"
        ).format("YYYY");
        return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
      },
      formatStartDate(date) {
        let vm = this;
        let startYear = moment(
          vm.$store.state.filterObj.startDate,
          "YYYY-MM-DD"
        ).format("YYYY");
        let endYear = moment(
          vm.$store.state.filterObj.endDate,
          "YYYY-MM-DD"
        ).format("YYYY");
        if (startYear == endYear) {
          return moment(date, "YYYY-MM-DD").format("DD MMM ");
        } else {
          return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
        }
      },

      generateHashKey(confirmationNumber) {
        let vm = this;
        let obj = {
          confirmationNumber: confirmationNumber,
        },
          sucessCallback = function (response) {
            if (response.data) {
              vm.Save_HashURL(response.data, confirmationNumber);
              // vm.$router.push("/guestInfoAndPayment/" + response.data);
            }
          },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/generateHashKey",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      Save_HashURL(hashKey, confirmationNumber) {
        let vm = this;
        let hashKeyValue = hashKey.replace(/\//g, "");
        hashKeyValue = hashKeyValue.replace(/#/g, "");
        let obj = {
          HashURL: hashKeyValue,
          fromQuote: false,
          ReservationId: vm.hashUrlReservationId,
          confirmationNumber: confirmationNumber,
        };
        let sucessCallback = function (response) {
          if (response) {
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/Save_HashURL",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
        // vm.$router.push("/guestInfoAndPayment/" + hashKey.toString());
        // vm.$router.push({ name: 'guestInfoDetails', params: { confirmationNumber: hashKeyValue } });
        vm.Get_FolioSummary();
      },
      saveNotesDetails(noteId, noteStatusId, sendEmail) {
        let vm = this,
          obj = {
            ReservationId: vm.hashUrlReservationId,
            NoteId: noteId,
            NoteTypeId: 2,
            noteStatusId: 0,
            taskTypeId: 1,
            isAutoGenerated: 1,
            NoteSubject: "Turnover cleaning",
            NoteDetails: "Turnover cleaning",
            IsActionReqd: 1,
            DateOrTimeDue: moment(vm.filterObj.endDate).format("YYYY-MM-DD"),
            reCalculateFolio: true,
            sendEmail: sendEmail,
            unitId: vm.selectedUnit.UnitId,
          },
          sucessCallback = function (response) {
            if (response.data) {
              console.log("guest info", response.data);
              vm.Get_FolioSummary();
            }
          },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/SaveNotesDetails",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      onChangeCountry: function (country) {
        let vm = this;
        $(".searchResultsCities").hide();
        vm.selectedStateAndCountry.CountryName = country.CountryName;
        vm.selectedStateAndCountry.CountryId = country.CountryId;
        vm.searchCountryOldValue = country.CountryName;
        vm.searchCountry = country.CountryName;
        vm.countryList = [];
      },
      onChangeCity: function (CityId) {
        let vm = this;
        $(".searchResultsCities").hide();
        let obj = {
          ModuleAction: "GetCityStateCountryById",
          CityId: CityId,
        };
        let sucessCallback = function (response) {
          console.log("response in searchCity", response);
          if (response.data) {
            let selectedoptions = null;
            selectedoptions = response.data;
            vm.searchCityOldValue = selectedoptions.CityName;
            vm.searchCountryOldValue = selectedoptions.CountryName;
            vm.searchStateOldValue = selectedoptions.StateName;
            vm.selectedStateAndCountry = selectedoptions;
            vm.searchCity = selectedoptions.CityName;
            vm.searchCountry = selectedoptions.CountryName;
            vm.searchState = selectedoptions.StateName;
            vm.cityList = [];
            vm.isSelectedFromList = true;
            //   vm.isCitySelected = true;
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/GetCityStateCountryById",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      onChangeState: function (state) {
        let vm = this;
        $(".searchResultsCities").hide();
        let obj = {
          ModuleAction: "GetCountryByStateId",
          StateId: state.StateId,
        };
        let sucessCallback = function (response) {
          console.log("response in searchCity", response);
          if (response.data) {
            vm.selectedStateAndCountry.StateName =
              response.data[0][0].StateName;
            vm.selectedStateAndCountry.StateId = response.data[0][0].StateId;
            vm.selectedStateAndCountry.CountryName =
              response.data[0][0].CountryName;
            vm.selectedStateAndCountry.CountryId =
              response.data[0][0].CountryId;
            vm.searchStateOldValue = response.data[0][0].StateName;
            vm.searchCountryOldValue = response[0][0].CountryName;
            vm.searchCountry = response.data[0][0].CountryName;
            vm.searchState = response.data[0][0].StateName;
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/GetCountryByStateId",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format("DD MMM ");
      },
      imageURLS(imgGuid) {
        let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
        if (isBase64) {
          return imgGuid;
        }
        return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
      },
      showPayment() {
        let vm = this;
        vm.showGuestDetails = false;
        vm.ShowPaymentDetails = true;
        vm.showTACdetails = false;
        vm.showGuestDetail = true;
        vm.showPaymentChangeButton = false;
        vm.showTACChangeButton = true;
        vm.showGuestChangeButton = true;
        vm.ShowTermsAndConditions = false;
        // vm.ThankuPage = false;
        // vm.$gtag.event({

        //     eventCategory: 'Change Button',
        //     eventAction: 'Payment Info Change'
        // })
      },
      showTAC() {
        let vm = this;
        if (window.outerWidth <= 1024) {
          vm.scrollPaymentPage();
        }
        vm.showGuestDetails = false;
        vm.ShowPaymentDetails = false;
        vm.ShowTermsAndConditions = true;
        vm.showTACdetails = true;
        vm.showPaymentChangeButton = false;
        vm.showTACChangeButton = false;
        vm.showGuestDetail = true;
        vm.showGuestChangeButton = true;
      },
      showGuest() {
        let vm = this;
        vm.$router.push(
          "/guestInfo/" + encodeURIComponent(vm.$route.params.confirmationNumber)
        );
        vm.showGuestInfo = false;
        vm.showGuestDetails = true;
        vm.ShowPaymentDetails = false;
        vm.showTACdetails = false;
        vm.showPaymentChangeButton = false;
        vm.showTACChangeButton = true;
        if (vm.showGuestDetails == true) {
          vm.showGuestChangeButton = false;
        } else {
          vm.showGuestChangeButton = true;
        }
        // vm.ThankuPage = false;
      },
      Get_FolioSummary: function () {
        let vm = this;
        let obj = {
          ModuleAction: "Get_FolioSummary",
          ReservationId: vm.hashUrlReservationId,
        };
        let sucessCallback = function (response) {
          if (response.data) {
            vm.folioItemCharges = response.data[0];
            vm.folioCharges = response.data[2][0];
            console.log("Get_FolioSummary", response.data);
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/Get_FolioSummary",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      GetFolioLedgerTransDetails_beforesave() {
        let vm = this;
        vm.filterObj.Persons = vm.$store.state.filterObj.Persons == -99 || vm.$store.state.filterObj.Persons == '' ? null : vm.$store.state.filterObj.Persons;
        vm.filterObj.Adults = vm.$store.state.filterObj.Adults == -99 || vm.$store.state.filterObj.Adults == '' ? null : vm.$store.state.filterObj.Adults;
        vm.filterObj.Children = vm.$store.state.filterObj.Children == -99 || vm.$store.state.filterObj.Children == '' ? null : vm.$store.state.filterObj.Children;
        if (vm.$route.params.confirmationNumber != -1) {
          console.log("here1");
          vm.Get_FolioSummary();
          return;
        }
        let obj = {
          FolioId: null,
          ReservationId: null,
          UnitId: vm.selectedUnit.UnitId,
          PropertyId: vm.selectedUnit.PropertyId,
          StartDate: vm.$store.state.filterObj.startDate,
          EndDate: vm.$store.state.filterObj.endDate,
          NumOfAdults: vm.filterObj.Adults,
          NumOfChildren: vm.filterObj.Children,
          Persons: vm.filterObj.Persons,
          RatePlanId: vm.$store.state.filterObj.RatePlanId
        };
        vm.folioItemCharges = [];
        vm.folioCharges = {};
        console.log("obj", obj);
        let sucessCallback = function (response) {
          console.log("response in GetFolioLedgerTransDetails", response);
          if (response && response.data) {
            if (response.data[0]) {
              vm.folioItemCharges = response.data[0];
            }
            if (response.data[2]) {
              vm.folioCharges = response.data[2][0];
            }
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/GetFolioLedgerTransDetails",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      showThankPage() {
        let vm = this;
        vm.showGuestDetails = false;
        // vm.ShowPay = false;
        // vm.ThankuPage = true;
        vm.savePaymentDetails();
      },
      updateStartDate(key, dateObj) {
        let scope = this;
        scope.cardInfo.Expirationdate = dateObj
          ? dateObj.format("MMM YYYY")
          : null;
        scope.cardInfo.ExpirationMonth = moment(
          scope.cardInfo.Expirationdate
        ).format("MM");
        scope.cardInfo.ExpirationYear = moment(
          scope.cardInfo.Expirationdate
        ).format("YYYY");
        console.log(
          "scope.cardInfo.ExpirationMonth",
          scope.cardInfo.ExpirationMonth
        );
      },
      showPaymentSection() {
        var vm = this;
        vm.ShowPaymentDetails = true;
        vm.showTACChangeButton = true;
      },
      getCardToken() {
        let vm = this;
        // if(vm.cardInfo.NameOnCard == "" || vm.cardInfo.NameOnCard == null){
        //     vm.$store.dispatch("toastr", {
        //         type: "warning",
        //         message: "Please Enter Name On Card",
        //         header: "Warning"
        //     });
        //     return;
        // }
        // else if(){
        // }
        vm.errorMessage = ""
        vm.enableCompleteButton = false;
        vm.loading = true;
        console.log("vm.stripeConnectedAccount", vm.stripeConnectedAccount);
        let currentYear = moment().format("YYYY");
        let currentMonth = moment().format("MM");
        if (vm.stripeConnectedAccount == null) {
          (vm.loading = false), (vm.enableCompleteButton = true);
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please connect stripe account",
          });
          return;
        } else if (
          !vm.cardInfo.CreditCard ||
          vm.cardInfo.CreditCard.length < 10 ||
          vm.cardInfo.CreditCard.length > 16
        ) {
          (vm.loading = false), (vm.enableCompleteButton = true);
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please enter valid card number",
          });
          return;
        } else if (isNaN(vm.cardInfo.CreditCard)) {
          (vm.loading = false), (vm.enableCompleteButton = true);
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please enter valid card number",
          });
          return;
        } else if (vm.cardInfo.ExpirationMonth == -1) {
          (vm.loading = false), (vm.enableCompleteButton = true);
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please select expiry month",
          });
          return;
        } else if (vm.cardInfo.ExpirationYear == -1) {
          (vm.loading = false), (vm.enableCompleteButton = true);
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please select expiry year",
          });
          return;
        } else if (
          Number(vm.cardInfo.ExpirationMonth) < currentMonth &&
          Number(vm.cardInfo.ExpirationYear) <= currentYear
        ) {
          (vm.loading = false), (vm.enableCompleteButton = true);
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please select valid expiry month/year",
          });
          return;
        } else if ((vm.$store.state.beData.StatusName == "Guaranteed" || vm.$store.state.beData.StatusName == "Confirmed") && (!vm.cardInfo.CVVCode || vm.cardInfo.CVVCode.length < 3 || vm.cardInfo.CVVCode.length > 4)) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please enter valid CVV"
          });
          return;
        }
        // else if (!vm.cardInfo.CVVCode || vm.cardInfo.CVVCode.length < 3 || vm.cardInfo.CVVCode.length > 4) {
        //     vm.loading = false,
        //         vm.enableCompleteButton = false;
        //     vm.$store.dispatch("toastr", {
        //         type: "warning",
        //         header: "Warning!",
        //         message: "Please enter valid CVV"
        //     });
        //     return;
        // }
        vm.disabledCompleteBookingButton = true
        let obj = {
          NameOnCard: vm.cardInfo.NameOnCard,
          CreditCard: vm.cardInfo.CreditCard,
          ExpirationMonth: vm.cardInfo.ExpirationMonth,
          ExpirationYear: vm.cardInfo.ExpirationYear,
          CVVCode: vm.cardInfo.CVVCode,
          AddressDetails: vm.cardInfo.AddressDetails,
          PostalCode: vm.cardInfo.PostalCode,
        },
          guestInfo = vm.guestInfo,
          email = vm.guestInfo.Emailaddress,
          phone = vm.guestInfo.PhoneNumber,
          sk_token = vm.stripePaltformAccount.SecretKey,
          stripeConnectedAccount = vm.stripeConnectedAccount;
        console.log("obj", obj);
        let sucessCallback = function (response) {
          console.log("response in getCardToken", response);
          if (response && response.data && response.data.message) {
            vm.Save_ErrorLogs(response.data.message);
            console.log("response.data.message", response.data.message);
            vm.loading = false;
            vm.enableCompleteButton = true;
            vm.disabledCompleteBookingButton = false
            vm.$store.dispatch("toastr", {
              type: "error",
              message: response.data.message,
              header: "Error",
            });
            return;
          }
          // else {
          //     vm.$store.dispatch("toastr", {
          //         type: "success",
          //         header: "Success!",
          //         message: "Payments Saved Successfully!"
          //     });
          // }
          if (response && response.data) {
            vm.cardToken = response.data.token.card;
            vm.cardTokenFromStripe = response.data.customer.id;
            vm.stripecardId = response.data.customer.default_source;
            console.log("vm.cardTokenFromStripe", vm.cardTokenFromStripe);
            vm.savePaymentCardDetails();
            if (vm.$gtag) {
              vm.$gtag.event("Booking Completed", {
                'event_category': 'Payment',
                'event_label': 'Payment',
              })
            }

            let resPersons = vm.selectedUnit.Persons
              ? vm.selectedUnit.Persons
              : vm.selectedUnit.NumberOfAdults && vm.selectedUnit.NumberOfAdults
                ? vm.selectedUnit.NumberOfAdults + vm.selectedUnit.NumberOfAdults
                : vm.selectedUnit.NumberOfAdults;
            console.log("resPersonsresPersons", resPersons);
            // vm.$ga.ecommerce.addItem({
            //   id: "HT" + vm.guestInfo.ConfirmationNumber, // Transaction ID. Required.
            //   name:
            //     vm.selectedUnit.PropertyNickName +
            //     "(" +
            //     vm.selectedUnit.UnitNickName +
            //     ")", // Product name. Required.
            //   sku: "HT" + vm.guestInfo.ConfirmationNumber, // SKU/code.
            //   category: "BE Reservations", // Category or variation.
            //   price: vm.folioCharges.TotalValue, // Unit price.
            //   quantity: 1,
            //   // "Confirmation": vm.confirmationNumber,
            //   // "Total": vm.folioCharges.TotalValue,
            //   // "Nights": vm.selectedUnit.Nights,
            //   // "ADR": vm.folioItemCharges[0].Adr,
            //   // "Booked On Date": vm.guestInfo.BookedDate,
            //   // "Arrival Date": vm.selectedUnit.originalStartDate,
            //   // "Unit Type": vm.selectedUnit.UnitTypeName,
            //   // "Unit Class": vm.selectedUnit.UnitClassName
            // });  
            if (vm.$gtag) {
              vm.$gtag.event('purchase', {
                transaction_id: "HT" + vm.guestInfo.ConfirmationNumber,
                value: vm.folioCharges.TotalValue,
                tax: vm.folioCharges.TotalTax,
                shipping: 0,
                currency: 'USD',
                CheckinDate: moment(vm.selectedUnit.originalStartDate).format("YYYY-MM-DD"),
                BookedDate: moment(vm.guestInfo.BookedDate).format("YYYY-MM-DD"),
                Nights: vm.selectedUnit.Nights,
                UnitTypeName: vm.selectedUnit.UnitTypeName,
                UnitClassName: vm.selectedUnit.UnitClassName,
                ADR: vm.folioItemCharges[0].Adr,
                RateplanName: vm.guestInfo.RateplanName,
                CheckoutDate: moment(vm.selectedUnit.originalEndDate).format("YYYY-MM-DD"),
                ClientCode: vm.guestInfo.ClientCode,
                UnitCharge: vm.folioItemCharges[0].Charges,
                CleaningFee: vm.folioItemCharges[1].Charges,
                PropertyName: vm.selectedUnit.PropertyName,
                items: [
                  {
                    item_id: "HT" + vm.guestInfo.ConfirmationNumber,
                    item_name: vm.selectedUnit.PropertyNickName + "(" + vm.selectedUnit.UnitNickName + ")",
                    quantity: 1,
                    price: vm.folioCharges.TotalValue,
                  },
                ]
              });
            }
            // vm.$ga.ecommerce.addTransaction({
            //   id: "HT" + vm.guestInfo.ConfirmationNumber, // Transaction ID. Required.
            //   revenue: vm.folioCharges.TotalValue,
            //   shipping: "0",
            //   tax: vm.folioCharges.TotalTax,
            //   currency: "USD",
            // });
            // vm.$gtag.event('Booking Data', {
            //   value: vm.folioCharges.TotalValue,
            //   tax: vm.folioCharges.TotalTax,
            //   shipping: 0,
            //   currency: 'USD',
            //   CheckinDate: vm.selectedUnit.originalStartDate,
            //   BookedDate: vm.guestInfo.BookedDate,
            //   Nights: vm.selectedUnit.Nights,
            //   UnitTypeName: vm.selectedUnit.UnitTypeName,
            //   UnitClassName: vm.selectedUnit.UnitClassName,
            //   Adr: vm.folioItemCharges[0].Adr,
            //   RateplanName: vm.guestInfo.RateplanName,
            //   CheckoutDate: vm.selectedUnit.originalEndDate,
            //   ClientCode: vm.guestInfo.ClientCode,
            //   Charges: vm.folioItemCharges[0].Charges,
            //   Charges1: vm.folioItemCharges[1].Charges,
            //   PropertyName: vm.selectedUnit.PropertyName
            // });
            // vm.$ga.set("dimension1", vm.selectedUnit.originalStartDate);
            // vm.$ga.set("dimension2", vm.guestInfo.BookedDate);
            // vm.$ga.set("dimension3", vm.selectedUnit.Nights);
            // vm.$ga.set("dimension4", vm.selectedUnit.UnitTypeName);
            // vm.$ga.set("dimension5", vm.selectedUnit.UnitClassName);
            // vm.$ga.set("dimension6", vm.folioItemCharges[0].Adr);
            // vm.$ga.set("dimension7", vm.guestInfo.RateplanName);
            // vm.$ga.set("dimension8", vm.selectedUnit.originalEndDate);
            // vm.$ga.set("dimension9", vm.guestInfo.ClientCode);
            // vm.$ga.set("dimension10", vm.folioItemCharges[0].Charges);
            // vm.$ga.set("dimension11", vm.folioItemCharges[1].Charges);
            // vm.$ga.set("dimension12", vm.selectedUnit.PropertyName);
            // vm.$ga.ecommerce.send();
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/getCardToken",
          "post",
          {
            cardInfo: obj,
            sk_token,
            guestInfo,
            email,
            phone,
            stripeConnectedAccount,
          },
          sucessCallback,
          failureCallback
        );
      },

      save_Notification(notificationEventId, notifSubEventId, amount) {
        let vm = this;
        var notificationToaster = null;
        var headerToaster = null;
        let sucessCallback = function (response) {
          if (response) {
            if (response && response.recordset[0] && response.recordset[0].EventDescription) {
              notificationToaster = response.recordset[0].Messagecontent;
              headerToaster = response.recordset[0].EventDescription;
            }

            if (notificationToaster != null) {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: ` ${headerToaster} `,
                message: ` ${notificationToaster} `
              });
            }

            console.log("response in save_Notification", response);
            //vm.get_NotificationCount();
          }
        }
        let failureCallback = function (error) {

          return;
          console.log(error);
        };
        vm.$store.state.sendApiRequest(
          "beApi/SaveNotification",
          "post",
          {
            ReservationId: vm.hashUrlReservationId,
            EventId: notificationEventId,
            PropertyId: vm.selectedUnit.PropertyId,
            SubEventId: notifSubEventId,
            Amount: amount ? amount : null,
          },
          sucessCallback,
          failureCallback
        );
      },
      get_NotificationCount() {
        let vm = this;
        sucessCallback = function (response) {
          console.log("response in get_NotificationCount", response);
        },
          failureCallback = function (error) {
            return;
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/GetNotificationCountByUser",
          "post",
          {

          },
          sucessCallback,
          failureCallback
        );
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetNotificationCountByUser",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.$store.commit('setNotificationCount', response.NotificationCount);
              console.log("response in get_NotificationCount", response);
            }
          },
        });
      },
      // tax
      Save_ErrorLogs(errorMessage) {
        let vm = this,
          obj = {
            PartyId: vm.hashUrlReservationId,
            PartyTypeId: 5,
            ErrorFrom: "SavePaymentDetails",
            RawResponse: errorMessage,
          };
        let sucessCallback = function (response) {
          console.log("response in Save_ErrorLogs", response);
          if (response && response.data) {
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/Save_ErrorLogs",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      // tax
      savePaymentCardDetails() {
        let vm = this;
        for (let ledger of vm.paymentLedgerAcounts) {
          if (vm.paymentCardType === ledger.PaymentMethod) {
            vm.cardInfo.PaymentTypeId = ledger.ledgerAccountID;
          }
        }
        let obj = {
          PaymentInfoId: vm.cardInfo.PaymentInfoId,
          partyId: vm.hashUrlReservationId,
          partyTypeId: 5,
          PaymentTypeId: vm.cardInfo.PaymentTypeId,
          NameOnCard: vm.cardToken.name ? vm.cardToken.name : vm.cardInfo.NameOnCard,
          CreditCard: null,
          ExpirationYear: vm.cardInfo.ExpirationYear,
          ExpirationMonth: vm.cardInfo.ExpirationMonth,
          CCLast4Digits: vm.cardToken.last4,
          CvvCode: null,
          IsDefault: 1,
          AddressDetails: vm.cardInfo.AddressDetails,
          PostalCode: vm.cardInfo.PostalCode,
        },
          Token = vm.cardTokenFromStripe,
          cardId = vm.stripecardId,
          stripeConnectedAccount = vm.stripeConnectedAccount,
          stripePaltformAccount = vm.stripePaltformAccount;
        console.log("obj", vm.cardInfo);
        let sucessCallback = function (response) {
          console.log("response in savePaymentCardDetails", response);
          if (response && response.data) {
            // vm.$store.dispatch("toastr", {
            //     type: "success",
            //     header: "Success!",
            //     message: "Payments Saved Successfully!"
            // });
            // vm.ThankuPage = true;

            (vm.loading = false), (vm.enableCompleteButton = false);
            vm.showGuestDetails = false;

            // vm.sendThankYouMail(vm.hashUrlReservationId);
            // vm.$router.push("/ThankYouPage/" + vm.hashUrlReservationId);
            Cookies.remove("idleTime");
            var date = new Date();
            date.setTime(date.getTime() + 30 * 60 * 1000);
            Cookies.set("idleTime", vm.$route.params.confirmationNumber, {
              expires: date,
            });
            // let NotificationEventID = [], NotiSubEventId;
            // let EventID, SubEventId, sub_event = null;
            // let bookedTimeInProperty = moment.tz(vm.selectedUnit.Timezone).format("YYYY-MM-DD HH:mm:ss");
            // // let diff = moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(bookedTimeInProperty,"DD/MM/YYYY HH:mm:ss"));
            // // let d = duration.asHours();
            // let startdate = moment(vm.selectedUnit.originalStartDate).format(
            //   "YYYY-MM-DD"
            // );
            // let checkintime = moment(vm.selectedUnit.checkInTime, ["h:mm A",]).format("HH:mm:ss");
            // let combinetime = startdate + " " + checkintime;
            // // var momentObj = moment(startdate + checkintime, 'YYYY-MM-DDLT');
            // // console.log("momentObjmomentObjmomentObj === ", combinetime)
            // // var dateTime = momentObj.format('YYYY-MM-DD HH:mm:ss');
            // // console.log("dateTimedateTimedateTime === ", dateTime)

            // let duration = moment(combinetime, "YYYY-MM-DD HH:mm:ss").diff(
            //   moment(bookedTimeInProperty, "YYYY-MM-DD HH:mm:ss")
            // );
            // let seconds = moment.duration(duration);
            // let hoursDiff = seconds.asHours();

            // if (vm.$route.params.email) {
            //   // EventID = 14
            //   // SubEventId = null
            //   let subEvent = null
            //   if (vm.statusId == 10 || vm.statusId == 12) {
            //     if (vm.guestInfo.LastminuteBooking &&
            //       vm.guestInfo.LastminuteBooking > 0 &&
            //       hoursDiff <= vm.guestInfo.LastminuteBooking) {
            //       subEvent = 2
            //     } else {
            //       subEvent = 1
            //     }
            //     let EventID = [
            //       { eventId: 1, subEventId: subEvent },
            //       { eventId: 4, subEventId: 15 },
            //     ];
            //     for (let event of EventID) {
            //       vm.getLogIdsByEventID(event.eventId, event.subEventId);
            //     }
            //     vm.save_Notification(1, subEvent, vm.notificationAmount)
            //   } else {
            //     vm.getLogIdsByEventID(2, 10);
            //     vm.save_Notification(2, 10, vm.notificationAmount)
            //   }
            // } else {
            //   // EventID = "1,3"
            //   console.log("vm.$store.state.beData", vm.$store.state.beData);

            //   // if(hoursDiff <= vm.guestInfo.LastminuteBooking && vm.$store.state.beData.StatusName == 'Inquiry'){
            //   //     SubEventId = "1,2,3"
            //   // }
            //   // else
            //   if (vm.$store.state.beData.StatusName == "Inquiry") {
            //     SubEventId = 3;
            //   }
            //   else if (vm.$store.state.beData.StatusName == "Request") {
            //     SubEventId = 26;
            //   }
            //   else if (
            //     vm.guestInfo.LastminuteBooking &&
            //     vm.guestInfo.LastminuteBooking > 0 &&
            //     hoursDiff <= vm.guestInfo.LastminuteBooking
            //   ) {
            //     SubEventId = 2;
            //     //  NotiSubEventId =2;             
            //   }
            //   else {
            //     SubEventId = 1;

            //   }
            //   EventID = [
            //     { eventId: 1, subEventId: SubEventId },
            //     { eventId: 4, subEventId: "15" },
            //   ];
            //   console.log("vm.$store.state.beData.StatusName = ", vm.$store.state.beData.StatusName)
            //   if (vm.$store.state.beData.StatusName == "Inquiry") {
            //     NotiSubEventId = 3;
            //   }
            //   else {
            //     NotiSubEventId = 1;
            //   }
            //   NotificationEventID = [
            //     { notificationEventId: 1, notiSubEventId: NotiSubEventId }
            //   ];
            //   // SubEventId = 6
            //   // vm.getLogIdsByEventID(EventID, SubEventId)
            //   for (let event of EventID) {
            //     vm.getLogIdsByEventID(event.eventId, event.subEventId);
            //   }
            //   for (let id of NotificationEventID) {
            //     vm.save_Notification(id.notificationEventId, id.notiSubEventId, vm.notificationAmount);
            //   }
            // }

            if (vm.$store.state.beData.StatusName == "Confirmed" || vm.$store.state.beData.StatusName == "Guaranteed") {
              vm.getPaymentCardDetails("processPayment")
            } else {
              
              vm.UpdateStatusofBEReservation(1)
              setTimeout(() => {
                vm.triggerBotOrNotification(2, 10);
                vm.ShowPaymentDetails = false;
                vm.$router.push({
                  name: "ThankYouPage",
                  params: {
                    confirmationNumber: encodeURIComponent(
                      vm.$route.params.confirmationNumber
                    ),
                  },
                });
                vm.disabledCompleteBookingButton = false;
              }, 2000);
            }
          }
        },
          failureCallback = function (error) {
            console.log(error);
            vm.disabledCompleteBookingButton = false
          };
        vm.$store.state.sendApiRequest(
          "beApi/savePaymentDetails",
          "post",
          {
            paymentDetails: obj,
            Token,
            cardId,
            stripeConnectedAccount,
            stripePaltformAccount,
          },
          sucessCallback,
          failureCallback
        );
      },
      UpdateStatusofBEReservation(PaymentStatus,payment) {
        let vm = this;
        let beResStatusObj = {
          reservationid: vm.hashUrlReservationId,
          BE_Id: vm.$store.state.beData.BE_Id,
          PaymentStatus: PaymentStatus
        }
        let sucessCallback = function (response) {
          console.log("UpdateStatusofBEReservation", response.data)
          if(PaymentStatus == 2 && payment == 'Payment Failed'){
            vm.triggerBotOrNotification(3, 28);
          }

        },
          failureCallback = function (error) {
            console.log("error in UpdateStatusofBEReservation", error);
          };
        vm.$store.state.sendApiRequest("beApi/UpdateStatusofBEReservation", "post", beResStatusObj, sucessCallback, failureCallback);
      },
      triggerBotOrNotification(paymenteventId, transactionType) {
        let vm = this;
        const bookedTime = moment.tz(vm.selectedUnit.Timezone).format("YYYY-MM-DD HH:mm:ss");
        const checkinTime = moment(vm.selectedUnit.checkInTime, ["h:mm A"]).format("HH:mm:ss");
        const combinetime = moment(vm.selectedUnit.originalStartDate).format("YYYY-MM-DD") + " " + checkinTime;
        const hoursDiff = moment(combinetime, "YYYY-MM-DD HH:mm:ss").diff(moment(bookedTime, "YYYY-MM-DD HH:mm:ss")) / (1000 * 60 * 60);

        const statusName = vm.$store.state.beData.StatusName;
        const isEmail = !!vm.$route.params.email;

        let subEvent = null
        let NotiSubEventId
        if (isEmail) {
          if (transactionType != 28 && (vm.statusId == 10 || vm.statusId == 12) && (statusName != "Inquiry" && statusName != "Request")) {
            subEvent = vm.guestInfo.LastminuteBooking && hoursDiff <= vm.guestInfo.LastminuteBooking ? 2 : 1
            NotiSubEventId = 1 ;
          }else{
            NotiSubEventId = transactionType == 28 && transactionType != 10 ? 22 : null;
          }
          
        } else {
          subEvent = statusName == "Inquiry" ? 3 : vm.statusId == 12 ? 26 : transactionType != 28 ? vm.guestInfo.LastminuteBooking && hoursDiff <= vm.guestInfo.LastminuteBooking ? 2 : 1 : 22;
          NotiSubEventId = transactionType == 28 && transactionType != 10 ? 1 : statusName == "Inquiry" ? 3 : 1 ;
        }
        // subEvent = isEmail ? (vm.statusId == 10 || vm.statusId == 12) && vm.guestInfo.LastminuteBooking && hoursDiff <= vm.guestInfo.LastminuteBooking ? 2 : 1 : statusName == "Inquiry" ? 3 : statusName == "Request" ? 26 : vm.guestInfo.LastminuteBooking && hoursDiff <= vm.guestInfo.LastminuteBooking ? 2 : 1;
        console.log("subEvent", subEvent)
        const EventID = [{ eventId: 1, subEventId: subEvent }, { eventId: 4, subEventId: subEvent ? 15 : null }, { eventId: paymenteventId, subEventId: transactionType == 12 ? transactionType : null }, { eventId: 2, subEventId: 10 }];
        EventID.forEach(event => { 
          if (event.subEventId) {
            event.eventId = event.subEventId == 22 ? 6 : event.eventId;
            vm.getLogIdsByEventID(event.eventId, event.subEventId)
          } 
        });

        const NotificationEventID = [{ notificationEventId: 1, notiSubEventId: isEmail ? subEvent : NotiSubEventId }, { notificationEventId: 2, notiSubEventId: 10, paymentAmount: vm.folioCharges && vm.folioCharges.TotalValue ? vm.folioCharges.TotalValue.replace(/\,/g, "") : null }, { notificationEventId: 3, notiSubEventId: transactionType ? transactionType : null, paymentAmount: vm.folioCharges && vm.folioCharges.TotalValue ? vm.folioCharges.TotalValue.replace(/\,/g, "") : null }];
        NotificationEventID.forEach(id => {
          if (id.notiSubEventId)
            id.notificationEventId = id.notiSubEventId == 22 ? 6 : id.notificationEventId;
            vm.save_Notification(id.notificationEventId, id.notiSubEventId, id.paymentAmount ? id.paymentAmount : null)
        });

      },
      getSurchargeForPayment(capture) {
        let vm = this;
        let sucessCallback = function (response) {
          console.log("response in getSurchargeForPayment", response);
          if (!response.data.reply) {
            vm.errorMessage = "Your attempted payment with the provided credit card details has unfortunately declined.  We recommend updating your payment method and/or contacting your bank for a solution before trying to book again.  Thank you."
            vm.ShowPaymentDetails = true;
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Payment Failed!",
              message: "Your payment failed. Please try again.",
            });
            vm.disabledCompleteBookingButton = false
            vm.UpdateStatusofBEReservation(2)
            return
          }
          let surchargeAmount = response.data.reply.datablock.surcharge
          vm.makeStripePayment(capture, surchargeAmount)
          // vm.UpdateStatusofBEReservation(1)
        },
          failureCallback = function (error) {
            console.log(error);
            vm.disabledCompleteBookingButton = false
            vm.UpdateStatusofBEReservation(2)
          };
        let surchargeObj = {
          stripeConnectedAccount: vm.stripeConnectedAccount,
          amount: vm.folioCharges.TotalValue.replace(/\,/g, ""),
          paymentCardDetails: vm.selectedPaymentCardDetails
        }
        vm.$store.state.sendApiRequest("beApi/getSurCharges", "post", surchargeObj, sucessCallback, failureCallback);
      },
      makeStripePayment(capture, surchargeAmount) {
        let vm = this;
        let sucessCallback = function (response) {
          console.log("response in MakestripePayment", response);

          if (response.data.message) {
            // vm.paymentProcessMethod = 3;
            // vm.chargeItem.chargeId = null;
            vm.errorMessage = "Your attempted payment with the provided credit card details has unfortunately declined.  We recommend updating your payment method and/or contacting your bank for a solution before trying to book again.  Thank you."
            vm.ShowPaymentDetails = true;
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Payment Failed!",
              message: "Your payment failed. Please try again.",
            });
            vm.disabledCompleteBookingButton = false
            vm.UpdateStatusofBEReservation(2,'Payment Failed')
            // vm.triggerBotOrNotification(3, 28);
            // vm.save_Notification(3, 28, vm.folioCharges && vm.folioCharges.TotalValue ? vm.folioCharges.TotalValue.replace(/\,/g, "") : null)
          }
          else {

            
            vm.UpdateStatusofBEReservation(1)

            setTimeout(() => {
              vm.triggerBotOrNotification(3, capture ? 12 : 27);
              vm.ShowPaymentDetails = false;
              vm.$router.push({
                name: "ThankYouPage",
                params: {
                  confirmationNumber: encodeURIComponent(
                    vm.$route.params.confirmationNumber
                  ),
                },
              });
              vm.disabledCompleteBookingButton = false;
            }, 2000);

          }
        },
          failureCallback = function (error) {
            console.log(error);
            vm.ShowPaymentDetails = true;
            vm.disabledCompleteBookingButton = false
            vm.UpdateStatusofBEReservation(1)
            // vm.save_Notification(3, 28, vm.folioCharges && vm.folioCharges.TotalValue ? vm.folioCharges.TotalValue.replace(/\,/g, "") : null)
            vm.triggerBotOrNotification(3, 28);
          };
        // let surchargeLedgerAcountId = vm.LedgerAcounts.filter((ledger) => {
        //   if (ledger.ledgerAccountName == "Payment Processing Fee") {
        //     return ledger;
        //   }
        // });
        let paymentObj = {
          paymentDetails: {
            PaymentInfoId: -1,
            PaymentTypeId: null,
            Amount: vm.folioCharges.TotalValue.replace(/\,/g, ""),
            dateEffective: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
          paymentCardDetails: vm.selectedPaymentCardDetails,
          stripePlatformAccount: vm.stripePaltformAccount,
          stripeConnectedAccount: vm.stripeConnectedAccount,
          commissionAmmount: vm.commissionAmmount,
          guestInfo: vm.guestInfo,
          roomInfo: vm.roomInfo,
          captureValue: capture,
          paymentStatusId: capture ? 7 : 1,
          dateEffective: moment().format("YYYY-MM-DD HH:mm:ss"),
          email: vm.guestInfo.Emailaddress,
          phone: vm.guestInfo.PhoneNumber,
          surchargeAmount: surchargeAmount,//vm.surchargeAmount,
          surchargeLedgerAcountId: vm.processingSurchargeLedgerAccount ? vm.processingSurchargeLedgerAccount.ledgerAccountID : null,//surchargeLedgerAcountId.length
          // ? surchargeLedgerAcountId[0].ledgerAccountID
          // : null,
        }
        vm.$store.state.sendApiRequest("beApi/makeStripePayment", "post", paymentObj, sucessCallback, failureCallback);
      },

      getLogIdsByEventID(eventId, SubEventId) {
        let vm = this,
          sucessCallback = function (response) {
            console.log("response in getLogIdsByEventID", response);
          },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/Get_LogDetails_ByEventId",
          "post",
          {
            ReservationId: vm.hashUrlReservationId,
            EventId: eventId,
            SubEventId: SubEventId,
          },
          sucessCallback,
          failureCallback
        );
      },

      sendThankYouMail(id) {
        let vm = this,
          sucessCallback = function (response) {
            console.log("response in thankyouMail", response);
          },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/thankyouMail",
          "post",
          {
            ReservationId: id,
            protocol: window.location.protocol,
            confirmationNumber: vm.$route.params.confirmationNumber,
          },
          sucessCallback,
          failureCallback
        );
      },
      getPaymentDetails() {
        let vm = this,
          obj = {
            ReservationId: vm.hashUrlReservationId,
          };
        let sucessCallback = function (response) {
          console.log("response in Get_PaymentDetails", response);
          if (response && response.data) {
            // vm.paymentDetails = response[0];
            // vm.paymentCharges = response[1][0];
            vm.paymentLedgerAcounts = response.data.recordsets[2];
            vm.stripePaltformAccount = response.data.recordsets[3][0];
            vm.stripeConnectedAccount = response.data.recordsets[4][0];
            vm.commissionAmmount = response.data.recordsets[5][0];
            vm.processingSurchargeLedgerAccount = response.data.recordsets[10][0]
            console.log("stripeConnectedAccount", vm.stripeConnectedAccount);
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/Get_PaymentDetails",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      getPaymentCardDetails(processPayment) {
        let vm = this,
          obj = {
            ReservationId: vm.hashUrlReservationId,
            PartyTypeId: 5
          };
        let sucessCallback = function (response) {
          console.log("response in getPaymentCardDetails", response);
          if (
            response &&
            response.data &&
            response.data[0] && response.data[0].length
          ) {
            // vm.cardInfo = response.data[0][0];
            let filteredCardData = response.data[0].filter(cardObj => {
              if (cardObj.CardToken == vm.cardTokenFromStripe) {
                return cardObj
              }
            })
            vm.selectedPaymentCardDetails = filteredCardData[0];
            if (processPayment && (vm.$store.state.beData.StatusName == "Confirmed" || vm.$store.state.beData.StatusName == "Guaranteed")) {
              let capture = vm.$store.state.beData.StatusName == "Guaranteed" ? true : false
              if (vm.stripeConnectedAccount.GatewayId != 2 || (vm.stripeConnectedAccount.GatewayId == 2 && vm.$store.state.beData.StatusName == "Confirmed")) {
                vm.makeStripePayment(capture)
              } else {
                vm.getSurchargeForPayment(capture)
              }

            }
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/Get_PaymentCardDetails",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      GetReservationDetailsByURL() {
        let vm = this,
          obj = {
            confirmationNumber: decodeURIComponent(
              vm.$route.params.confirmationNumber
            ),
          };
        // vm.showGuestInfo = true
        console.log(
          "vm.$route.params.confirmationNumber",
          vm.$route.params.confirmationNumber
        );
        let sucessCallback = function (response) {
          console.log("response in GetReservationDetailsByURL", response);
          if (
            response &&
            response.data &&
            response.data.recordsets[0] &&
            response.data.recordsets[0][0]
          ) {
            // ExpireDate IsExpired
            // if (response.data.recordsets[0][0].IsExpired == 1) {
            //     vm.showGuestInfo = false;
            // }
            // else {
            vm.showGuestInfo = true;
            vm.hashUrlReservationId =
              response.data.recordsets[0][0].ReservationId;
            vm.confirmationNumber =
              response.data.recordsets[0][0].ConfirmationNumber;
            vm.GetReservationDetailById();
            vm.getPaymentDetails();
            vm.getPaymentCardDetails();
            vm.Get_FolioSummary();
            // }
          } else {
            // vm.hashUrlReservationId = -1
            vm.GetReservationDetailById();
            vm.getPaymentDetails();
            vm.getPaymentCardDetails();
            // vm.Get_FolioSummary();
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        vm.$store.state.sendApiRequest(
          "beApi/GetReservationDetailsByURL",
          "post",
          obj,
          sucessCallback,
          failureCallback
        );
      },
      initGMapWidth() {
        this.$nextTick(this.resizeEvent);
        window.addEventListener("resize", this.resizeEvent);
        // this.isLoading = false;
      },
      resizeEvent() {
        setTimeout(() => {
          let vm = this;
          let cw = this.$refs.guestInfo.clientWidth;
          // console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", cw);
          if (cw <= 797 && cw != "768") {
            console.log("mmmmmmmmmmmmmmmmmmmmmmmmmm");
            vm.isWebView = false;
            if (window.innerHeight < window.innerWidth) {
              vm.showPriceInfo = true;
              vm.showPriceText = "Close";
              // if (vm.showGuestDetails) {
              //     setTimeout(() => {
              //         var etop = $(".guestWrap").offset().top + 195;
              //         $('html, body').animate({
              //             scrollTop: etop
              //         }, 350);
              //     }, 100)
              // }
              // else if (vm.ShowPaymentDetails) {
              //     setTimeout(() => {
              //         var etop = $(".paymentWrap").offset().top + 80;
              //         $('html, body').animate({
              //             scrollTop: etop
              //         }, 350);
              //     }, 100)
              // }
            } else {
              vm.showPriceInfo = false;
              vm.showPriceText = "Details";
            }
          } else {
            console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwww");
            vm.isWebView = true;
            vm.showPriceInfo = false;
            vm.showPriceText = "Details";
          }
        }, 100);
      },
      routeChangeEvent() {
        if (vm.$gtag) {
          vm.$gtag.pageview({
            page_title: 'Payment Info-Page',
            page_location: window.location.href,
            page_path: vm.$route.path,
          })
        }
      },
    },
    computed: {
      expiryYears() {
        let currYear = new Date().getFullYear();
        let years = [];
        years.push(currYear);
        for (let yIndex = 1; yIndex <= 16; yIndex++) {
          years.push(currYear + yIndex);
        }
        return years;
      },
      unit() {
        let vm = this;
        console.log(
          "this.$store.getters.getUnitsData",
          vm.$store.getters.getUnitsData
        );
        return vm.$store.getters.getUnitsData;
      },
      filterObj() {
        let vm = this;
        console.log(
          "this.$store.getters.getAvailableUnitsList",
          this.$store.getters.getFilteredData
        );
        // vm.getAvailableRooms();
        return this.$store.getters.getFilteredData;
      },
      isVaildSubDomain() {
        let vm = this;
        return vm.$store.state.isValidDomainOrNot;
      },
      beCssObj() {
        if (this.$store.state.cssObj) return this.$store.state.cssObj;
        return null;
      },
      mapWraperLoaded() {
        return this.isVaildSubDomain;
      },
    },
    mounted() {
      let vm = this;
      // vm.GetReservationDetailById();
      vm.$store.state.bus.$emit("hidingSearch", false);
      setTimeout(() => {
        if (vm.$gtag) {
          vm.$gtag.pageview({
            page_title: 'Payment Info-Page',
            page_location: window.location.href,
            page_path: vm.$route.path,
          })
        }
      }, 100);
      if (vm.$route.params.confirmationNumber == -1) {
        vm.showGuestChangeButton = false;
      } else {
        vm.showGuestChangeButton = true;
      }
      // vm.showGuestChangeButton = true;
      vm.GetReservationDetailsByURL();
      if (this.$store.state.cssObj) {
        var para = document.createElement("style");
        para.innerText = this.$store.state.cssObj;
        //console.log("para.innerText", para.innerText);
        var body = document.getElementById("BETemplateBody");
        body.appendChild(para);
      }
      // setTimeout(() => {
      //     this.resizeEvent();
      //     window.addEventListener('resize', this.resizeEvent);
      // }, 100)
      if (this.mapWraperLoaded) {
        this.initGMapWidth();
      }
      vm.showTAC();
    },
    watch: {
      mapWraperLoaded(newValue, oldValue) {
        console.log("newValue", newValue);
        if (newValue !== oldValue && newValue === true) {
          this.initGMapWidth();
        }
      },
      isVaildSubDomain(isAvail) {
        if (isAvail) {
          // this.GetReservationDetailById();
          this.getPaymentDetails();
          this.getPaymentCardDetails();
          this.GetFolioLedgerTransDetails_beforesave();
          this.GetReservationDetailsByURL();
        }
      },
      beCssObj() {
        //console.log(this.beCssObj);
        if (this.beCssObj) {
          var para = document.createElement("style");
          para.innerText = this.beCssObj;
          //console.log("para.innerText", para.innerText);
          var body = document.getElementById("BETemplateBody");
          body.appendChild(para);
        }
      },
      searchCity(newValue, oldValue) {
        let vm = this;
        vm.cityList = [];
        vm.guestInfo.CityName = newValue;
        let obj = {
          ModuleAction: "GetCitySearch",
          SearchLocation: newValue,
          SearchId: 1,
        };
        let sucessCallback = function (response) {
          console.log("response in searchCity", response);
          if (response.data) {
            if (newValue && oldValue) {
              //console.log("vm.cityList", vm.cityList)
              vm.cityList = response.data;
            }
            console.log(" vm.cityList", vm.cityList);
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        if (vm.searchCityOldValue != vm.searchCity) {
          if (newValue.length > 0) {
            vm.$store.state.sendApiRequest(
              "beApi/GetCitySearch",
              "post",
              obj,
              sucessCallback,
              failureCallback
            );
          }
        }
      },
      searchState(newValue, oldValue) {
        let vm = this;
        vm.stateList = [];
        vm.guestInfo.StateName = newValue;
        if (vm.selectedStateAndCountry.StateName != newValue && oldValue)
          vm.selectedStateAndCountry.StateId = null;
        vm.guestInfo.StateName = newValue;
        let obj = {
          ModuleAction: "GetCitySearch",
          SearchLocation: newValue,
          SearchId: 2,
        };
        let sucessCallback = function (response) {
          console.log("response in searchState", response);
          if (response.data) {
            if (newValue && oldValue) {
              vm.stateList = response.data;
            }
            // console.log(" vm.stateList", vm.stateList);
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        if (vm.searchStateOldValue != vm.searchState) {
          if (newValue.length > 0) {
            vm.$store.state.sendApiRequest(
              "beApi/GetCitySearch",
              "post",
              obj,
              sucessCallback,
              failureCallback
            );
          }
        }
      },
      searchCountry(newValue, oldValue) {
        let vm = this;
        vm.countryList = [];
        vm.guestInfo.CountryName = newValue;
        if (vm.selectedStateAndCountry.CountryName != newValue && oldValue)
          vm.selectedStateAndCountry.CountryId = null;
        vm.guestInfo.CountryName = newValue;
        let obj = {
          ModuleAction: "GetCitySearch",
          SearchLocation: newValue,
          SearchId: 3,
        };
        let sucessCallback = function (response) {
          console.log("response in searchCountry", response);
          if (response.data) {
            if (newValue && oldValue) {
              vm.countryList = response.data;
            }
            console.log(" vm.countryList", vm.countryList);
          }
        },
          failureCallback = function (error) {
            console.log(error);
          };
        if (vm.searchCountryOldValue != vm.searchCountry) {
          if (newValue.length > 0) {
            vm.$store.state.sendApiRequest(
              "beApi/GetCitySearch",
              "post",
              obj,
              sucessCallback,
              failureCallback
            );
          }
        }
      },
      $route: "routeChangeEvent",
    },
    created() {
      let vm = this;
      $("html, body").animate({ scrollTop: 0 });
      vm.GetReservationDetailsByURL();
      // vm.GetReservationDetailById();
      vm.GetFolioLedgerTransDetails_beforesave();
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.resizeEvent);
      // window.removeEventListener('scroll', this.callWindowScrollEvent);
      // $(window).unbind('scroll');
      // this.prevScrollpos = 0;
      // document.getElementById("page-content").style.padding = "";
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/paymentInfoDetails/paymentInfoDetails.vue